import React from 'react';

import { isEqual } from 'lodash';

import { siteIds } from '../../../constants';
import { siteId, brandSite } from '../../../sites';

import ViinimaaRootWrapper from './viinimaa';

function RootWrapper(props) {
  if (isEqual(siteId, siteIds.Viinimaa)) {
    return <ViinimaaRootWrapper {...props} />;
  }
  if (isEqual(siteId, siteIds.Folkofolk)) {
    return <ViinimaaRootWrapper {...props} />;
  }
  if (brandSite) {
    return <ViinimaaRootWrapper {...props} />;
  }

  return null;
}

export default RootWrapper;
